import React, {useEffect, useState} from 'react';
import {nav_items} from "../../../nav_items";
import {NavLink} from "react-router-dom";
import {Tooltip as ReactTooltip} from "react-tooltip";
import {LayoutGrid, X} from "lucide-react";
import Logo from "../Logo";
import classNames from "classnames";

const Nav = (props) => {
    const {authorized} = props
    const [nav, setNav] = useState([])
    const [isMobile, setIsMobile] = useState(false)
    const [navOpen, setNavOpen] = useState(false)

    const NavItem = ({item}) => {
        return <li data-tooltip-id={item.id} className={'nav_items_item'}><NavLink className={'link_inner'}
                                                                                   to={item.path}>
            {item.icon}
            <span className={'nav_items_item_title'}>{item.title}</span>
        </NavLink>
        </li>
    }

    const detectResize = () => {
        if (window.innerWidth < 1024) {
            setIsMobile(true)
        } else {
            setIsMobile(false)
        }
    }

    useEffect(() => {
        if (window.innerWidth < 1024) {
            setIsMobile(true)
        }

        window.addEventListener('resize', detectResize)

        return () => {
            window.removeEventListener('resize', detectResize)
        }
    }, [])

    useEffect(() => {

        if (authorized) {
            if (isMobile) {
                setNav(nav_items.filter(el => el.id === 'home' || el.id === 'leader_board' || el.id === 'transactions'))
            } else {
                setNav(nav_items)
            }
        } else {
            setNav(nav_items.filter(el => el.id === 'home'))
        }
    }, [nav_items, authorized, isMobile]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <nav className={'nav'}>
            {isMobile && <div
                className={classNames({
                    'nav_mobile': true,
                    'open': navOpen
                })}
            >
                <div className="nav_mobile_header">
                    <Logo/>
                    <X onClick={() => setNavOpen(false)} className={'close_icon'}/>
                </div>
                <ul className={'nav_mobile_list'}>
                    {nav_items.map(item => {
                        return <li
                            className={'nav_mobile_item'}
                        >
                            <NavLink
                                onClick={() => setNavOpen(false)}
                                className={'link_inner'}
                                to={item.path}
                            >
                                {item.icon}
                                <span className={'nav_mobile_item_title'}>{item.title}</span>
                            </NavLink>
                        </li>
                    })}
                </ul>
            </div>}
            <ul className={'nav_items'}>
                {nav.map(item => {
                    return <NavItem
                        activeClassName={'active'}
                        key={item.title}
                        item={item}
                    />
                })}
                {isMobile && authorized && <li className={'nav_items_item'}>
                    <div className={'link_inner'}>
                        <LayoutGrid
                            onClick={() => setNavOpen(!navOpen)}
                        />
                        <span className={'nav_items_item_title'}>{"More"}</span>
                    </div>
                </li>}
                {!isMobile && nav.map(item => {
                    return <ReactTooltip
                        className={'tooltip nav_tooltip'}
                        key={item.id}
                        id={item.id}
                        place="right"
                        content={item.title}
                    />
                })}
            </ul>
        </nav>
    );
};

export default Nav;